<template>
    <div class="stickers__preview">
        <div
            v-if="!previewIsLoading"
            class="stickers__preview-bg"
            :style="{
                backgroundImage: `url(${ preview['preview_large'] || '../img/pay/stream.jpg' })`
            }"
        >
            <iframe
                allow="autoplay"
                v-if="livePreview"
                :src="autoplayChange(preview['url'])"
            />
        </div>

        <div
            class="stickers__preview-widget"
            :class="[(previewIsActive && 'stickers__preview-widget_active'), (stickerInCross && 'stickers__preview-widget_active-cross')]"
            ref="preview"
            @mousemove="trackSticker"
        >
            <div
                class="stickers__preview-item"
                :class="[sticker.isActive ? 'stickers__preview-item_active' : '']"
                v-for="sticker in widget"
                :key="sticker._id"
                v-dnd="sticker"
                :style="{
                    width: 10 * sticker.scale + '%',
                    top: sticker.top + '%',
                    left: sticker.left + '%',
                    transform: 'translate(-50%, -50%) rotate(' + sticker.angle + 'deg)',
                    backgroundImage: `url(${ sticker.url })`
                }"
                @mouseup="dellSticker(sticker._id)"
            >
                <span
                    class="stickers__preview-item__rotate"
                    v-rotate="sticker"
                />

                <span
                    class="stickers__preview-item__resize stickers__preview-item__resize_tr"
                    v-resize="sticker"
                />
                <span
                    class="stickers__preview-item__resize stickers__preview-item__resize_rb"
                    v-resize="sticker"
                />
                <span
                    class="stickers__preview-item__resize stickers__preview-item__resize_bl"
                    v-resize="sticker"
                />
                <span
                    class="stickers__preview-item__resize stickers__preview-item__resize_lt"
                    v-resize="sticker"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACTIONS as ACTIONS_STICKERS } from '../../store/stickers'

import {
    JustDnD,
    JustRotate,
    JustResize,
} from '../../directives/sticker.js'

JustDnD()
JustRotate()
JustResize()

export default {
    name: 'Preview',

    components: {},

    props: ['livePreview'],

    data: () => {
        return {
            previewIsActive: false,
            stickerInCross: false,
        }
    },

    computed: {
        ...mapGetters({
            preview: 'preview',
            previewIsLoading: 'previewIsLoading',
            widget: 'widget',
        }),
    },

    mounted() {
        this.$store.dispatch(ACTIONS_STICKERS.FETCH_STREAM_PREVIEW)
    },

    methods: {
        autoplayChange(str) {
            return str.replace(/autoplay=(false|0)/i, 'autoplay=true') + '&mute=true'
        },

        trackSticker(e) {
            const
                activeSticker = this.widget.filter(s => s.isActive),
                previewRect = this.$refs.preview.getBoundingClientRect()

            if ( activeSticker.length > 0 ) {
                this.previewIsActive = true

                const
                    x = e.pageX - previewRect.left,
                    y = e.pageY - previewRect.top - window.scrollY
    
                if ( ( x >= previewRect.width / 2 - 18 && x <= previewRect.width / 2 + 18 ) && ( y >= previewRect.height - 18 - 36 && y <= previewRect.height - 18 ) ) {
                    this.stickerInCross = true
                } else {
                    this.stickerInCross = false
                }
            } else {
                this.previewIsActive = false
            }
        },

        dellSticker(id) {
            if (this.previewIsActive && this.stickerInCross) {
                this.$store.dispatch(ACTIONS_STICKERS.SET_UPDATE_STICKERS, id)
            }

            this.previewIsActive = false
            this.stickerInCross = false
        }
    },
}
</script>

<style lang='scss' scoped>
.stickers {
    &__preview {
        border-radius: 4px;
        overflow: hidden;
        position: relative;

        &-item {
            background-size: 96%;
            background-position: center center;
            background-repeat: no-repeat;
            position: absolute;
            border: 1px dotted transparent;
            backface-visibility: hidden;
            transition: border-color .2s;

            &:after {
                display: block;
                content: '';
                padding-top: 100%;
            }

            &__resize {
                position: absolute;
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 2px;
                cursor: grab;
                opacity: 0;
                transform: scale(0);
                transition: all .2s;

                &:active {
                    cursor: grabbing;
                }

                &_tr {
                    top: -5px;
                    right: -5px;
                }

                &_rb {
                    right: -5px;
                    bottom: -5px;
                }

                &_bl {
                    bottom: -5px;
                    left: -5px;
                }

                &_lt {
                    left: -5px;
                    top: -5px;
                }
            }

            &__rotate {
                position: absolute;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                border: 5px solid #fff;
                background-color: rgba(197, 197, 197, 1);
                top: - 7px;
                left: 50%;
                transform: translate(-50%, 0);
                cursor: grab;
                opacity: 0;
                transform: translate(-50%, 0) scale(0);
                transition: all .2s;

                &:active {
                    cursor: grabbing;
                }
            }
        }

        &:after {
            display: block;
            content: '';
            padding-top: (9 / 16) * 100%;
        }

        &-bg {
            position: absolute;
            z-index: 1;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: .75;

            iframe {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 0;
            }
        }

        &-widget {
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            &:after {
                display: block;
                content: '';
                position: absolute;
                width: 36px;
                height: 36px;
                border-radius: 6px;
                border: 2px solid #fff;
                background-color: rgba(#000, .2);
                background-image: url(/img/close.svg);
                background-repeat: no-repeat;
                background-position: center center;
                left: 50%;
                bottom: -18px;
                opacity: 0;
                transform: translate(-50%, -50%);
                pointer-events: none;
                transition: all .2s;
            }

            &_active {
                &:after {
                    opacity: 1;
                    bottom: 0;
                }

                &-cross {
                    &:after {
                        opacity: 1;
                        bottom: 0;
                        background-color: rgba(#d32f2f, .5);
                    }
                }
            }
        }
    }
}

.stickers__preview-item:hover,
.stickers__preview-item_active {
    border-color: #fff;

    .stickers__preview-item__resize {
        opacity: 1;
        transform: scale(1);
    }

    .stickers__preview-item__rotate {
        opacity: 1;
        transform: translate(-50%, 0) scale(1);
    }
}
</style>